import React, { Fragment, useContext, useState } from 'react';
import { LangCtx } from "../../../lib/context";
import "../Styles.css";
import "./doctorInvites.css";
import "../../../ui-styles/animations/ripple.css";
import "../../../ui-styles/buttons/ButtonFilled.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import "../../../ui-styles/buttons/IconButton.css";
import '../../../ui-styles/list/ListAutoUnderLine.css';
import "../../../ui-styles/search/Search.css";
import BtmDeleteSlide from '../../../lib/ui/BtmDeleteSlider';
import { deleteInvitees } from '../../../actions/schedule';
import Loading from '../../../components/loading';
import { toast } from 'react-toastify';


const DoctorInvitesList = (props) => {
    const {l} = useContext(LangCtx);

    const [slideD, setSlideD] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleSlideD = () => {
        setSlideD(true);
    }

    const handleSlideDClose = () => {
        setSlideD(false);
    }

    const handeDelete = () => {
        try {
            setLoading(true);
            let body = {
                email: props?.data?.email
            }
            deleteInvitees(body, props?.data?._id).then(res => {
                setLoading(false);
                if (res.status) {
                    toast.success('Email Deleted Successfully', {
                        position:toast.POSITION.TOP_RIGHT
                    })
                    props.loadData();
                    setSlideD(false);
                    setLoading(false);
                }
            }).catch(err => {
                setLoading(false);
        setSlideD(false);
                toast.error(err?.response?.data?.error, {
                    position:toast.POSITION.TOP_RIGHT
                })
                //  setErrorMsg("Unable to delete Invitee.")
            });
        } catch (e) {
            setLoading(false);
        setSlideD(false);
            console.log("Error", e);
            setLoading(false);
            toast.error(e?.response?.data?.error,{
                position:toast.POSITION.TOP_RIGHT
            })
            //  setErrorMsg(l.went_worng_pls_try_again)
        }
    }
    return (
        <Fragment>
            {loading && <Loading/>}
            <div className="listAutoUL" key={props.data.id}>
                <div className="listAutoAvtr Md primarySL">
                    {props.data.imageUrl ?
                        <img src={props.data.imageUrl} alt="avatar" />
                        :
                        <img src="/images/icons/doctor-default.png" alt="avatar" />
                    }
                </div>
                <div className="listAutoContent">
                    <span className="listTxtL">{props.data.name}</span>
                    <span className="listTxtM">{props.data.email}</span>
                    {/* <span className="listTxtM">{patient.number}</span> */}
                </div>
                <div className="listAutoAction">
                    <div className="iconBtnBlock primary Sm ripple" onClick={handleSlideD}>
                        <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary"/>
                    </div>
                </div>
            </div>
            {slideD && <BtmDeleteSlide slideD={slideD} handleCancel={handleSlideDClose} txt={l.conf_del} handleConfirm={() => handeDelete()} />}
        </Fragment>
    )
}

export default React.memo(DoctorInvitesList); 